import { useEffect, useState } from 'react'

export const useIsSingleColumn = () => {
	const [isSingleColumn, setIsSingleColumn] = useState(false)

	useEffect(() => {
		const mediaQuery = window.matchMedia('(max-width: 576px)')
		const update = () => setIsSingleColumn(mediaQuery.matches)

		update()
		mediaQuery.addEventListener('change', update)

		return () => mediaQuery.removeEventListener('change', update)
	}, [])

	return isSingleColumn
}
